import React from "react";
import { ViewItem, PartnerDailyReport } from "..";
import { useEffect } from "react";
import { INavigableComponent } from "../../../../interfaces";
import { ToolbarContextEnum } from "../../../../enums";

interface ItemPageProps {
  config: any;
  data: any;
}

export default function ItemPage({
  config,
  data,
  setToolbarConfig,
}: ItemPageProps & INavigableComponent) {
  const mode = 'view';
  const SelectedComponent = data._id === 'partner_daily_report' ? <PartnerDailyReport/> : <ViewItem data={data}/>;

  useEffect(() => {
    let context = ToolbarContextEnum.ViewItem;
    setToolbarConfig?.({ ...config, context, item: data });
  }, [config, data, mode, setToolbarConfig]);
  
  return SelectedComponent;
}
